import React, {useEffect} from 'react';
import {getCalApi} from "@calcom/embed-react";
import ContactModal from "../ContactModal";

function Libre1() {

    useEffect(()=>{
        (async function () {
            const cal = await getCalApi({"namespace":"ligne-inclusion"});
            cal("ui", {"styles":{"branding":{"brandColor":"#000000"}},"hideEventTypeDetails":false,"layout":"month_view"});
        })();
    }, [])

    return (
            <section className="libre layout-pt-50 layout-pb-20 text-center page-lahalle">
                <div className="auto-container">
                    <div className="text-center">
                        <h4 className="libre-title mt-2 mb-4 raleway">
                            <span>Handicap, maladie chronique, difficultés au travail liées à votre santé… un échange peut tout changer !</span>
                        </h4>

                        <div className="nunito">
                            Dans le cadre de l’engagement de La Halle pour le handicap et l’inclusion,
                            ce service « <b>Hotline Handicap</b> » dédié à nos collaborateurs et à nos managers,
                            vous permet d’échanger sur rendez-vous avec des experts
                            de notre partenaire Talents Handicap, pour répondre de manière
                            personnalisée et confidentielle<sup>*</sup> à vos questions sur le handicap au travail
                            et son lien avec la santé, la prévention et le bien-être au travail.
                        </div>
                        <h2 className="libre-title mt-2 mb-1 raleway">
                            <div style={{fontSize: "30px"}}>Nos experts sont disponibles <span>chaque mercredi de 14h à 17h</span></div>
                        </h2>
                    </div>

                    <ContactModal
                        textButton="Réserver mon RDV avec un expert"
                        showText={false}
                        small=""
                        linkPageContact={false}
                        iframe={true}
                        couleur={true}
                        page="lahalle"
                    />
                    <div className="small text mt-15 nunito">
                        <small>
                            Talents Handicap, partenaire de confiance, s’engage à ne communiquer vos coordonnées
                            à personne, y compris aux équipes La Halle, garantissant l’anonymat et la confidentialité de vos échanges.
                        </small>
                    </div>
                </div>
            </section>
    );
}

export default Libre1;
